
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/matches/[slug]",
      function () {
        return require("private-next-pages/matches/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/matches/[slug]"])
      });
    }
  